import "../styles/animated-backgrounds.css";

export default function AnimatedBackground({
	cue,
	colour1 = "",
	colour2 = "",
}) {
	return (
		<>
			{cue.animationName === "moving_gradient" && (
				<MovingGradient colour1={colour1} colour2={colour2} />
			)}
			{cue.animationName === "floating_bulbs" && (
				<FloatingBulbs colour1={colour1} colour2={colour2} />
			)}
		</>
	);
}

const MovingGradient = ({ colour1, colour2 }) => {
	return (
		<div
			className={`w-screen h-screen
            gradient_rotate
    `}
			style={{
				background: `linear-gradient(130deg, ${colour1}, ${colour2})`,
				WebkitBackgroundSize: `200% 200%`,
			}}
		></div>
	);
};

const FloatingBulbs = ({ colour1, colour2 }) => {
	return (
		<div
			className={`w-screen h-screen
            floating_bulbs
    `}
			style={{ background: colour1 }}
		>
			<div className="absolute w-screen h-screen flex justify-center items-center filter blur-2xl  overflow-hidden">
				<div
					style={{ backgroundColor: colour2 }}
					className="bulb bulb_1 absolute top-10 -left-20 w-4/12 h-6/12 mix-blend-multiply  rounded-full"
				></div>
				<div
					style={{ backgroundColor: colour2 }}
					className="bulb bulb_1 absolute -top-4 left-2 w-4/12 h-6/12 mix-blend-multiply  rounded-full"
				></div>
				<div
					style={{ backgroundColor: colour2 }}
					className="bulb bulb_3 absolute bottom-0 -left-7 w-4/12 h-6/12 mix-blend-multiply rounded-full"
				></div>
				<div
					style={{ backgroundColor: colour2 }}
					className="bulb bulb_3 absolute left-20 w-4/12 h-6/12 mix-blend-multiply rounded-full"
				></div>
				<div
					style={{ backgroundColor: colour2 }}
					className="bulb bulb_2 absolute bottom-0  w-4/12 h-6/12 mix-blend-multiply rounded-full"
				></div>
				<div
					style={{ backgroundColor: colour2 }}
					className="bulb bulb_3 absolute top-0  w-4/12 h-6/12 mix-blend-multiply rounded-full"
				></div>
				<div
					style={{ backgroundColor: colour2 }}
					className="bulb bulb_2 absolute top-30 right-26  w-4/12 h-6/12 mix-blend-multiply rounded-full"
				></div>
				<div
					style={{ backgroundColor: colour2 }}
					className="bulb bulb_3 absolute top-10 right-7 w-4/12 h-6/12 mix-blend-multiply rounded-full"
				></div>
				<div
					style={{ backgroundColor: colour2 }}
					className="bulb bulb_1 absolute bottom-10 right-2 w-4/12 h-6/12 mix-blend-multiply rounded-full"
				></div>
			</div>
		</div>
	);
};
